export const apiBaseUrl = 'http://39.106.76.187:8064/' // 远程接口请求地址

// export const apiBaseUrl = 'http://127.0.0.1:8064/' // 本地接口请求地址
